import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

const URL = environment.PROCEDURE_SECURITY_URI;

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private http: HttpClient)
  { }

  traerUsuarios(): Observable<any>{
    return this.http.get<any>(`${ URL }/GetUsers`);
  }

  traerUsuario(nombre: string): Observable<any>{
    return this.http.get<any>(`${ URL }/GetUsers?type=nombre&search=${ nombre }`);
  }

  guardarUsuario(usuario: any): Observable<any>{
    return this.http.post<any>(`${ URL }/user/insert`, usuario);
  }

  traerUsuarioById(codigo: string): Observable<any>{
    return this.http.get<any>(`${ URL }/GetUsers?type=codigo&search=${ codigo }`);
  }
  guardarAplicativoRolUsuario(usuario:any): Observable<any>{
    return this.http.put<any>(`${ URL }/UpdateUserRoleAplications/${ JSON.parse(localStorage.getItem('currentUser')+"").userId }`, usuario);
  }
  traerUsuarioByIdRolIdAplicacion(idAplicativo:string, idRol:string){
    return this.http.get<any>(`${ URL }/GetUsers?type=doble&search=${ idAplicativo }/${ idRol }`);
  }
  traerUsuarioByIdRolIdAplicacionUsuario(idAplicativo:string, idRol:string, usuario:string){
    return this.http.get<any>(`${ URL }/GetUsers?type=triple&search=${ idAplicativo }/${ idRol }/${ usuario }`);
  }
  traerAcciones():Observable<any>{
    return this.http.get<any>(`${ URL }/GetAsignaciones`);
  }

  traerAccionesRol():Observable<any>{
    return this.http.get<any>(`${ URL }/GetAsignacionesRol`);
  }
}
